<script>
import http from '../core/network/http.js'

function getFilteredReferences(params) {
  return http.post('/api/references/filter', params)
}
function getReference(code, actualLoop) {
  return http.post('/api/references/' + code, {'loop': actualLoop})
}

function getFilteredReferencesExternal(params) {
  return http.post('/api/loop/'+'loop_external'+'/references', params)
}
function getFilteredReferencesInternal(params) {
  return http.post('/api/loop/'+'loop_usual_components'+'/references', params)
}
function getFilteredReferencesTrading(params) {
  return http.post('/api/loop/'+'loop_trading'+'/references', params)
}
function removeReference(reference) {
  return http.delete('/api/references/' + reference)
}
function createKanbanReference (params) {
  return http.post('/api/admin/kanban_reference', params)
}
function getExternalLoopReferences () {
  return http.get('/api/loop/all/loop_external/references')
}

export default {
  getFilteredReferences,
  getFilteredReferencesExternal,
  getFilteredReferencesInternal,
  getFilteredReferencesTrading,
  removeReference,
  getReference,
  createKanbanReference,
  getExternalLoopReferences
}
</script>


// WEBPACK FOOTER //
// src/api/reference.vue